export default {
  wellSelected: null,
};
